
import React from 'react'

import common from '../../../assets/common.jpg'
import MegaNavbar from '../../../Components/MegaNavbar'
import DrAsimaAzam_CV from '../../../assets/CVs/Zoology/DrAsimaAzam_CV.pdf'
import DrIRAMMAQSOOD_CV from '../../../assets/CVs/Zoology/DrIRAMMAQSOOD_CV.pdf'
import DrSumbal_CV from '../../../assets/CVs/Zoology/DrSumbal_CV.pdf'
import Footer from '../../../Components/Footer'

const Zoology = () => {
  return (
    <>
    <MegaNavbar/>
     <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Zoology</h2>
        <div className="underline"></div>
        <p> Faculty of Zoology.</p>
      </div>

      <div className="row">

      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Asima Azam </h4>
              <span>Assistant Professor Department of Zoology.</span>
              <p>Assistant Professor Deportment Zoology Shaheed Benazir Bhutto Women University Peshawar. </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>   asimaazam@sbbwu.edu.pk  </p>
              <div className="social">
                <a href={DrAsimaAzam_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 


      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Iram Maqsood  </h4>
              <span>Assistant Professor Department of Zoology.</span>
              <p>Assistant Professor Department of Zoology, Shaheed Benazir Bhutto Women University Peshawar. </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> dr.irammaqsood@sbbwu.edu.pk </p>
              <div className="social">
                <a href={DrIRAMMAQSOOD_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>

      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Sumbal Haleem  </h4>
              <span>Lecturer Department of Zoology.</span>
              <p>Lecturer Department of Zoology, Shaheed Benazir Bhutto Women University Peshawar .</p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> sumbalhaleem@sbbwu.edu.pk  </p>
              <div className="social">
                <a href={DrSumbal_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 
 

        {/* Repeat the above structure for other team members */}

      </div>

    </div>
  </section>
      <Footer/>      

  
    </>
  )
}

export default Zoology
